import { render } from "./PaymentOk.vue?vue&type=template&id=412d965d"
import script from "./PaymentOk.vue?vue&type=script&lang=js"
export * from "./PaymentOk.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__